const pre = 'history-';

export default [
  {
    path: '/history/historyInfo',
    name: `${pre}historyInfo`,
    meta: {
      title: '数据中心',
      auth: ['history']
    },
    component: () =>
      import ('@/views/history/historyInfo')
  }
]
